export enum OwnerKind {
    User = "user",
    Organization = "org"
}
